import ConvidarPerfil from './ConvidarPerfil'
import enhancer from './ConvidarPerfil.enhancer'

export default enhancer(ConvidarPerfil)


// WEBPACK FOOTER //
// ./src/routes/admin/ConsultaPerfisAdmin/componentes/ConvidarPerfil/index.js